module.exports = __webpack_public_path__ + "static/1-011-e307a19c9bb97c6051d07c4ff40c8195.png";